import { DialogService } from '../../dialogs/dialog.service';
import { Injectable, NgZone } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpService } from '../../http/http.service';
import { IPluginDefinition } from './ck-editor-fetch-web-page-content-plugin.service.model';
import { CDFetchWebContentCommand } from './cd-fetch-web-content-command/cd-fetch-web-content-command';
import { Editor } from './cd-fetch-web-content-command/cd-fetch-web-content-command.model';

@Injectable({ providedIn: 'root' })
export class CkEditorFetchWebPageContentPluginService implements IPluginDefinition {
  readonly toolbarTooltipCaption: string;

  constructor(
    private dialogService: DialogService,
    public zone: NgZone,
    public httpService: HttpService,
    private translate: TranslateService
  ) {
    this.toolbarTooltipCaption = translate.instant('COMMON.DIALOGS.FETCH_WEB_PAGE_CONTENT.CK_EDITOR_BUTTON_TOOLTIP');
    CKEDITOR.plugins.add('cd-fetch-web-page-content', this);
  }

  init(editor: Editor): void {
    editor.addCommand('fetchWebPageContentData', new CDFetchWebContentCommand(this.dialogService, this.translate, this.zone));

    if (editor.ui.addButton) {
      editor.ui.addButton('CdFetchWebPageContent', {
        icon: `/assets/images/importweb.png`,
        label: this.toolbarTooltipCaption,
        command: 'fetchWebPageContentData',
        toolbar: 'clickDimensionsActions'
      });
    }
  }
}